// removed by extract-text-webpack-plugin
module.exports = {"landingHeaderSlant":"src-assets-css----landing-module---landingHeaderSlant---1gt5b","landingLogo":"src-assets-css----landing-module---landingLogo---1CIP2","bgBlueGrad":"src-assets-css----landing-module---bgBlueGrad---2nkGO","bgPurpleGrad":"src-assets-css----landing-module---bgPurpleGrad---3gFxb"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/landing.module.css
// module id = 107
// module chunks = 35783957827783 245289150788666